import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: ['./event.component.scss'],
})
export class EventComponent implements OnInit {
  eventSelected!: any;
  eventId!: any;
  loaded = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private eventsService: EventsService
  ) {
    this.activatedRoute.params.subscribe((data) => {
      this.eventId = data['idEvent'];
      if (this.eventId) {
        this.eventsService.getEventById(this.eventId).subscribe((response) => {
          this.loaded = true;
          this.eventSelected = response.data;
        });
      }
    });
  }

  ngOnInit(): void {}
}
